<template>
    
    <div id="entrepreneur_page">
        <div class="centered" v-if="item">
            <a class="close" @click="close_yazam"  :class="{active: displayYazam}">
                <div class="icon close_icon"></div>
            </a>
            <div class="yazam_wrap_scroll">
                <div class="yazam_card">
                    <div class="info">
                        <div class="titles">
                            <div class="first_titles">
                                <div class="title" v-text="item.display_name"></div>
                                <div v-text="item.data?.company_name"></div>
                                <div v-text="item.data?.link_company_site"></div>
                            </div>
                            <div class="num_projects" v-if="item.type === 'entrepreneur'">
                                <div class="icon_wrap">
                                    <div class="icon building_white_icon"></div>
                                </div>
                                <div> השתתף ב {{item.projects?.length + item.projects_urban?.length}} מכרזים</div>
                            </div>
                            <div class="num_projects" v-if="item.type === 'lawyer'">
                                <!-- <div class="icon_wrap">
                                    <div class="icon building_white_icon"></div>
                                </div>
                                <div> השתתף ב {{item.projects?.length + item.projects_urban?.length}} מכרזים</div> -->
                                <!-- <i class="far fa-building"></i> -->
                                <div class="icon_wrap">
                                    <div class="icon building_white_icon"></div>
                                </div>
                                <p class="project_details"><strong  v-text="item.total_projects"></strong> מכרזים במערכת מתוכם <strong v-text="item.open_projects"></strong> בסטטוס פתוח</p>
                            </div>
                        </div>
                        <div class="contact">
                            <div class="detail">
                                <div class="icon_wrap">
                                    <div class="icon location_icon"></div>
                                </div>
                                <div v-text="item.data?.company_address"></div> 
                            </div>
                            <div class="detail">
                                <div class="icon_wrap">
                                    <div class="icon phone_icon"></div>
                                </div>
                                <div v-text="(item.data?.phone_company_contact || item.data?.company_office_phone)" ></div>
                            </div>
                            <div class="detail">
                                <div class="icon_wrap">
                                    <div class="icon contact_icon"></div>
                                </div>
                                <div v-text="item.username"></div>
                            </div>
                            <div class="detail">
                                <div class="icon_wrap">
                                    <div class="icon email_icon"></div>
                                </div>
                                <div v-text="item.data?.link_company_site"></div>
                            </div>
                        </div>
                    </div>
                    <div class="yazam_img" :style="bg(item.data?.company_logo)"></div>
                </div>
                <div class="yazam_content">
                    <ul v-if="item.type === 'entrepreneur'">
                        <li v-for="tab in tabs" :key="tab.name" :class="{active: currTab==tab.name}">
                            <div @click="currTab=tab.name" v-text="tab.title"></div>
                        </li>
                    </ul>
                    <div class="tab" v-if="currTab=='about' || item.type=== 'lawyer'">
                        <h2 v-if="item.type=== 'lawyer'">אודות החברה</h2>
                        <div class="about_text" v-if="item.data?.about_company" v-text="item.data?.about_company"></div>
                        <div class="work_class">
                            <div class="working_areas" v-if="item.data?.activity_areas">
                                <div class="title">אזורי פעילות</div>
                                <div class="areas">
                                    <div v-for="work_area in item.data?.activity_areas" :key="work_area">
                                        <div class="work_area" v-text="work_area.name"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="classification" v-if="item.data?.classification_type_text">
                                <div class="title">סיווג קבלני</div>
                                <div v-text="item.data?.classification_type_text"></div>
                            </div>
                        </div>
                        <div class="links" v-if="item.data?.company_presentation || item.data?.promotional_video_link || item.data?.linkedin_link || item.data?.facebook_link">
                            <div class="title">קישורים נוספים</div>
                            <div class="actions">
                                <a target="_blank" v-if="item.data?.company_presentation" :href="item.data?.company_presentation" class="btn2 text_s"><div class="icon download_icon"></div>הורדת מצגת מהחברה</a>
                                <a target="_blank" v-if="item.data?.promotional_video_link" :href="item.data?.promotional_video_link" class="btn2 text_s"><div class="icon play_icon"></div>צפייה בסרטון תדמית</a>
                            </div>
                            <div class="soci">
                                <div v-if="item.data?.linkedin_link">
                                    <a target="_blank" :href="item.data?.linkedin_link" class="btn2 text_s"><div class="icon linkedin_icon"></div></a>
                                </div>
                                <div v-if="item.data?.facebook_link">
                                    <a target="_blank" :href="item.data?.facebook_link" class="btn2 text_s"><div class="icon facebook_icon"></div></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab" v-if="currTab=='details' || item.type === 'lawyer'">
                        <h2 v-if="item.type=== 'lawyer'">פרטים מקצועיים</h2>
                        <div class="working_with" v-if="item.type === 'entrepreneur'">
                            <div class="title">עובדים עם הגופים הבאים</div>
                            <div class="entity_wrap">
                                <div class="entity" v-if="item.data?.banks_financial_support">
                                    <div>בנקים</div>
                                    <div class="spec_entity_wrap">
                                        <div v-for="spec_entity in item.data?.banks_financial_support" :key="spec_entity">
                                            <div class="spec_entity" v-text="spec_entity.name"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="entity" v-if="item.data?.insurance_companies">
                                    <div>חברות ביטוח</div>
                                    <div class="spec_entity_wrap">
                                        <div v-for="spec_entity in item.data?.insurance_companies" :key="spec_entity">
                                            <div class="spec_entity" v-text="spec_entity.name"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="entity" v-if="item.data?.financing_companies">
                                    <div>חברות מימון חוץ בנקאיות</div>
                                    <div class="spec_entity_wrap">
                                        <div v-for="spec_entity in item.data?.financing_companies" :key="spec_entity">
                                            <div class="spec_entity" v-text="spec_entity.name"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="prof_rated" v-if="rates.length">
                            <div class="title">דירוגים מקצועיים</div>
                            <div class="rated">
                                <template  v-for="(rated,i) in rates" :key="i">
                                    <div class="rated_comp" :class="{not_active: !rated.active, checked: rated.checked }"  @mouseover="rated.hover=true" @mouseleave="rated.hover=false">
                                        <div :class="'pic '+rated.class" ></div>
                                        <a target="_blank" class="link" :href="rated.link" v-if="rated.hover && rated.active && rated.link != ''"><div class="icon watch_icon"></div>לצפייה</a>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="people" v-if="item.staff">
                            <div class="title">בעלי תפקידים בהתחדשות עירונית</div>
                            <div class="persons">
                                <div v-for="(person,i) in item.staff" :key="i" class="person">
                                    <div class="person_img" :class="{nopic: person.pic_parsed==''}" :style="person.pic_parsed != '' ? bg(person.pic_parsed) : ''"></div>
                                    <div class="title" v-text="person.name"></div>
                                    <div v-text="person.title"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab" v-if="currTab=='more_details' || item.type=== 'lawyer'">
                        <div class="card_b">
                            <div class="head only" >
                                <div class="sec" v-if="item.projects">
                                    <div class="title">התחדשות בניינית</div>
                                    <div>{{item.projects?.length + ' פרוייקטים'}}</div>
                                </div>
                                <div class="sec" v-if="item.projects_urban">
                                    <div class="title">התחדשות מתחמית</div>
                                    <div>{{item.projects_urban?.length + ' פרוייקטים'}}</div>
                                </div>
                                <div class="sec">
                                    <div class="title">סה"כ</div>
                                    <div>{{(item.projects?.length + item.projects_urban?.length) + ' פרוייקטים'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="card_b active" v-if="item.projects?.length > 0">
                            <div class="head">
                                <div  class="title">התחדשות בניינית</div>
                            </div>
                            <div class="content" >
                                <div v-for="(building, i) in item.projects" :key="i">
                                    <div class="clause">
                                        <div class="title2">#{{i+1}}</div>
                                        <div>
                                            <div class="title2">כתובת</div>
                                            <div v-text="building.address"></div>
                                        </div>
                                        <div>
                                            <div class="title2">כמות יחידות</div>
                                            <div>{{building.num_before}} לפני {{building.num_after}} אחרי</div>
                                        </div>
                                        <div>
                                            <div class="title2">סטטוס</div>
                                            <div v-text="building.status"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card_b active" v-if="item.projects_urban">
                            <div class="head">
                                <div  class="title">התחדשות מתחמית</div>
                            </div>
                           <table style="width: 100%;">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>כתובת</th>
                                        <th>כמות יחידות</th>
                                        <th>סטטוס</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(building, i) in item.projects_urban" :key="i">
                                        <td>{{i+1}}</td>
                                        <td v-text="building.address"></td>
                                        <td>{{building.num_before}} לפני {{building.num_after}} אחרי</td>
                                        <td v-text="building.status"></td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import popup from '@/components/popup.vue';

export default {
    computed: {popup},
    // props: ['item'],
    data() {
        return {
            displayYazam: false,
            closeYazam: false,
            rates: [],
            item: {},
            selected_content: 0,
            currTab: "about",
            tabs: [{
                    name: "about",
                    title: "אודות החברה"
                },
                {
                    name: "details",
                    title: "פרטים מקצועיים"
                  
                },
                
            ]
        }
    },
    beforeMount() {
        this.api({action: 'users/get' ,data: {id: this.$route.params.id }}, (data) => {
            this.item = data.data;
            
            // this.tabs.push({ name: "about", title: "אודות החברה" })
            // // if (this.item.type === 'entrepreneur') {
            //     this.tabs.push({name: "details", title: "פרטים מקצועיים"})
            // // }
            if (this.item.type === 'entrepreneur') {
                this.tabs.push({ name: "more_details", title: "פירוט על הפרוייקט"})
            }

            if(this.item.data?.bdi_report_file) this.rates.push({class:'bdi_icon', link: this.item.data?.bdi_rating_link, active: true, checked: false, hover: false});
            if(this.item.data?.duns_report_file) this.rates.push({class:'duns_icon', link: this.item.data?.bdi_rating_link, active: true, checked: false, hover: false});
            if(this.item.data?.urban_renewal_rating_link) this.rates.push({class:'madad_icon', link: this.item.data?.bdi_rating_link, active: true, checked: false, hover: false});
            
            setTimeout(() => {
                this.displayYazam = true;
            }, 100)
        });
    },
    mounted() {
        if (this.item.type === 'entrepreneur') {
            this.tabs.push({
                    name: "more_details",
                    title: "פירוט על הפרוייקט",
                })
        }
        
    },
    methods: {
        close_yazam() {
            this.closeYazam = true;
            setTimeout(() => {
                this.$bus.$emit('close_yazamdata')
            }, 500)
        }
    }
};
</script>

<style lang="scss" scoped>
*{color: var(--dark_blue);font-weight: 500;}
.title {color: var(--title_color);font-weight: 600;}
.title2 {color: var(--text_s);}
.bg_wrap {width: 100%;position: fixed;height: 100%;top: 0;right: 0;z-index: 999999;background: var(--darkBG);}
.icon_wrap {border: none;background-color: var(--very_light_blue);width: 32px;height: 32px;border-radius: 100%;background-size: 80%;display: flex;justify-content: center;align-items: center;}
.icon {width: 22px;height: 22px;}
.close { &{position: absolute; top: 20%; right: -50px; transform: translateX(100%); width: 40px; height: 40px; background: white; border: 1px solid var(--text_s); border-radius: 16px; display: none; justify-content: center; align-items: center;} &.active {display: flex;} }
.centered {
    .yazam_wrap_scroll { background: white; width: 100%; height: 100%; padding: var(--gap_mid); display: flex;flex-direction: column;gap: var(--gap_big);}
    .yazam_content {
        &{padding: 0 0 0 var(--gap_xbig);display:flex;flex-direction: column;gap: var(--gap_big);}
        ul {
            &{display: flex; gap: var(--gap_mid); overflow: auto;border-bottom: 1px solid var(--Border-card-hover, #80A3B6);}
            li { 
                &{position: relative; flex-shrink: 0; cursor: pointer; display: flex; gap: 5px;color:var(--text_s);font-weight: 700;}
                &.active {
                    &{color:var(--title_color)}
                    &::after {content: ''; position: absolute; bottom: 0; right: 0; left: 0; background: var(--title_color); height: 4px; border-radius: 8px;}
                    span {color: var(--title_color);}
                }
                &:not(.active) {
                    div {color: var(--text_s)}
                }
                div { padding-bottom: 10px;font-size: 20px;font-family: var(--font2);}
                span {color: var(--text_s); font-size: var(--h4);}
            }
        }
        .tab {
            &{display: flex;flex-direction: column;justify-content: center;gap: var(--gap_xbig);}
            h2 { font-size: var(--h2); font-weight: bold;}
            .about_text { white-space: pre-wrap; max-width: 80%;} 
            .card_b {
                .head {
                    &.only{justify-content: center;}
                    .sec {display: flex;gap: var(--gap);padding:var(--gap);
                    &:nth-child(2) {border-left: 1px solid var(--pageBG);border-right: 1px solid var(--pageBG)}}
                }
                .content {padding:0 !important}
                .clause {display: flex;justify-content: space-around;padding: var(--gap_mid) var(--gap_big);align-items: center;border-bottom: 1px solid var(--pageBG);}
            }
            .work_class{
                &{display:flex;gap:var(--gap_xbig)}
                .working_areas {
                    &{display: flex;flex-direction: column;gap: var(--gap);}
                    .areas {
                        &{display: grid;grid-template-columns: repeat(3, 1fr);gap:12px;}
                        .work_area {
                            background: var(--gray);border: 1px solid var(--pageBG);display: flex;justify-content: center;align-items: center;border-radius: var(--radius_x);padding: 8px 32px;
                        }
                    }
                }
                .classification{ 
                    &{display: flex;flex-direction: column;gap: var(--gap);}
                }
            }
            .links{
                &{display: flex;flex-direction: column;gap: var(--gap);}
                .actions {display: flex;gap: var(--gap);}
                .soci {
                    &{display: flex;justify-content: flex-start;gap: var(--gap)}
                    div {width: fit-content;}
                    .btn2 {width: 42px;height: 42px;}
                }
                .btn2 {
                    &{box-shadow: var(--box-shadow);min-height: 40px;border: solid 1px var(--text_s);border-radius: 12px;display: flex;justify-content: center;align-items: center;text-align: center;font-size: var(--h5);flex-basis: 27%;gap: 4px;}
                    .icon {width: 24px;height: 24px;}
                }
            }
            .working_with {
                &{display: flex;flex-direction: column;gap: var(--gap);}
                .entity_wrap{
                     &{display: flex;flex-wrap: wrap;gap: var(--gap_mid) var(--gap_xbig);}
                    .entity {
                        display: flex;flex-direction: column;gap: var(--gap);
                        .spec_entity_wrap {
                            &{display: grid;grid-template-columns: repeat(3, 1fr);gap:12px;}
                            .spec_entity {
                                background: var(--gray);border: 1px solid var(--pageBG);display: flex;justify-content: center;align-items: center;border-radius: var(--radius_x);padding: var(--gap_small) var(--gap);
                            }
                        }
                    }
                }
            }
            .prof_rated {
                &{display: flex;flex-direction: column;gap: var(--gap_mid);}
                .rated {
                    &{display: flex;gap: var(--gap_xmid);flex-wrap: wrap;}
                    .rated_comp {
                        &{border: 1px solid var(--light_blue);width: 200px;height: 150px;box-shadow: 1px 6px 12px 0px #002D551A;border-radius: var(--radius);display: flex;justify-content: center;align-items: center;position: relative;}
                        &.not_active {
                            &{border: 1px solid var(--pageBG);box-shadow:none;}
                            .pic {opacity: 0.5;}
                        }
                        &.checked {
                            &::after {content: "";display: block;position: absolute;top: -10%;right: 6%;height: 45px;aspect-ratio: 1;background: url("../assets/verified.svg");background-size: contain;background-repeat: no-repeat;}

                        }
                        .link {
                            display: flex;justify-content: center;align-items: center;gap:5px;
                            position: absolute;bottom: 10%;right: 12px;background: var(--gray); font-weight: 700;text-decoration: underline;padding: var(--gap_small) var(--gap);border-radius: var(--radius_s);}
                        .pic {width: 110px;aspect-ratio: 1;background-size: contain;background-repeat: no-repeat;}
                    }
                }
            }
            .people {
                &{display: flex;flex-direction: column;gap:var(--gap);}
                .persons {
                    &{display: grid;grid-template-columns: repeat(4,1fr); gap: var(--gap_mid) var(--gap_xmid);}
                    .person {
                        .title{line-height: 1.4;;font-weight: 700;}
                        .person_img {
                            &{width: 100%;aspect-ratio: 1;background-size: cover;background-repeat: no-repeat}
                            &.nopic {background-image: url("../assets/no_pic.svg");}
                        }
                    }
                }
            }
        }
    }
    table {
        width: 100%;
        border-collapse: collapse; /* Ensures borders collapse into a single line */
    }

    thead th, tbody td {
        padding: 8px;
        text-align: right;
        width: auto;
    }

    th { font-weight: bold;}

    th, td {
        border: 1px solid #ddd; /* Optional: Adds a border for visibility */
    }
}
</style>